export default __webpack_public_path__ + "static/media/other-services.6f2db657.jpg";